<template>
  <div
    :class="{ 'load load--fill': isLoading }"
    class="p-4 py-8"
  >
    <section class="max-w-lg mx-auto">
      <form @submit.prevent>
        <fieldset>
          <div class="field-list">
            <div class="field mb-4">
              <input
                id="managedPageTitle"
                v-model="form.title"
                name="managedPageTitle"
                :class="{ error: form.errors.has('title') }"
                placeholder="Managed Page Title"
                type="text"
              >
              <span
                v-if="form.errors.has('title')"
                class="field__meta__help"
                v-text="form.errors.get('title')"
              />
            </div>
            <div class="field mb-4">
              <input
                id="managedPageOrder"
                v-model="form.order"
                name="managedPageOrder"
                :class="{ error: form.errors.has('order') }"
                placeholder="Managed Page Order"
                type="text"
              >
              <span
                v-if="form.errors.has('order')"
                class="field__meta__help"
                v-text="form.errors.get('order')"
              />
            </div>
            <div class="field mb-8">
              <div v-if="form.icon">
                <img
                  :src="form.icon"
                  class="rounded"
                >
              </div>
              <div
                v-else
                class="w-full"
              >
                <BaseDropzone
                  id="dropzone"
                  ref="CreateBlogFormDropzone"
                  :options="dropzoneOptions"
                  @dropzone-error="uploadHasErrored"
                  @dropzone-sending="fileIsUploading"
                  @dropzone-success="fileHasBeenUploaded"
                />
                <span
                  v-if="form.errors.has('icon')"
                  class="field__meta__help"
                  v-text="form.errors.get('icon')"
                />
              </div>
              <div class="flex flex-row-reverse mt-2 items-baseline">
                <a
                  v-if="form.icon"
                  class="text-xs"
                  href="#"
                  @click.prevent="removeIcon"
                  v-text="'Remove Icon?'"
                />
              </div>
            </div>
            <div class="field">
              <Redactor
                v-model="form.content"
                :config="redactorConfig"
              />
              <span
                v-if="form.errors.has('content')"
                class="field__meta__help"
                v-text="form.errors.get('content')"
              />
            </div>
          </div>
        </fieldset>
        <div class="text-center mt-6">
          <button
            :class="{ load: isLoading }"
            :disabled="isUploading"
            :aria-disabled="isUploading"
            class="btn"
            @click="publish"
            v-text="'Publish Managed Page'"
          />
          <a
            :disabled="isUploading"
            :aria-disabled="isUploading"
            href="#"
            class="ml-6"
            @click.prevent="saveAsDraft"
            v-text="'Save draft'"
          />
        </div>
      </form>
    </section>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'
import Form from 'Base/Resources/assets/js/plugins/Form'

export default {
  name: 'EditManagedPage',
  props: {
    managedPageUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      isUploading: false,
      uploadErrors: '',
      form: new Form({
        title: '',
        content: '',
        icon: '',
        order: '',
        isDraft: false,
      }),
      dropzoneOptions: {
        url: this.$urlGenerator.active('api/v1/images?storagePath=managedPages'),
        paramName: 'image',
        dictDefaultMessage: 'Upload icon',
        acceptedFiles: 'image/*',
      },
      redactorConfig: {
        plugins: ['video', 'alignment'],
        showSource: true,
      },
    }
  },
  computed: {
    ...mapState({
      managedPage: state => state.managedPage.managedPage,
    }),
  },
  mounted() {
    this.getManagedPage(this.managedPageUuid).then(() => {
      this.isLoading = false

      this.form.title = this.managedPage.attributes.title
      this.form.content = this.managedPage.attributes.content
      this.form.icon = this.managedPage.attributes.icon
      this.form.order = this.managedPage.attributes.order
    })
  },
  methods: {
    ...mapActions({
      getManagedPage: 'managedPageGetManagedPage',
      updateManagedPage: 'managedPageUpdateManagedPage',
    }),
    publish(){
      this.form.isDraft = false

      this.save()
    },
    saveAsDraft(){
      this.form.isDraft = true

      this.save()
    },
    save() {
      this.isLoading = true

      this.updateManagedPage({
        uuid: this.managedPageUuid,
        data: this.form,
      })
        .then((response) => {
          window.location = this.$urlGenerator.active(
            `managed-pages/${response.data.uuid}`
          )
        })
        .catch((errors) => {
          this.form.setErrors(errors.response.data)

          this.isLoading = false
        })
    },
    removeIcon() {
      this.form.icon = ''
    },
    fileIsUploading() {
      this.isUploading = true
    },
    uploadHasErrored(file, response) {
      let errorMessage = response.message

      this.isUploading = false

      if (response.errors.icon) {
        errorMessage = response.errors.icon[0]
      }

      file.previewElement.querySelectorAll('.dz-error-message')[0].innerHTML = errorMessage

      this.$store.commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: errorMessage,
      })

      this.errors = response.errors
    },
    fileHasBeenUploaded(file, response) {
      this.form.icon = response

      this.isUploading = false
    },
  },
}
</script>
